import React from "react";
import { useState, useEffect } from "react";
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
import './TimecardFollowup.css';
import TimeSheetGrid from "../../Components/TimeCardFollowUpGrid/TimeSheetGrid";
import AutoCrawlSection from "../../Components/TimeCardFollowUpGrid/AutoCrawlSection"
import { Button, Layout, Modal, Select, Tooltip } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { callTimecardsGrid, getAutocrawlData, TSCsvDownload, downloadXL } from "../../Repository/TimecardFollowupRepository"
const { Header, Content } = Layout;

const TimesheetTeam = () => {
    const [showPopup, setShowPopup] = useState(false);
    const [loader, setLoader] = useState(false)
    const [statusData, setStatusData] = useState([])
    const [autocrawlData, setAutoCrawlData] = useState([]);
    const [tableLoader, setTableLoader] = useState(false)
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    const [csvLoader, setCsvLoader] = useState(false)
    const [frequency, setFrequency] = useState('');
    const [vms, setVms] = useState('')

    useEffect(() => {
        callGrid();
    }, [frequency, vms])
    const callGrid = async () => {
        try {
            setTableLoader(true)
            const res = await callTimecardsGrid(frequency, vms)
            if (res != null) {
                setStatusData(res)
            }
            setTableLoader(false)
        }
        catch {
            setTableLoader(false)
        }
    }
    const openPopup = async () => {
        try {
            setLoader(true)
            setShowErrorMsg(false)
            const res = await getAutocrawlData();
            if (res !== null) {
                if (res.BatchLabel === "Auto Crawl Process Not Completed") {
                    setShowErrorMsg(true);
                }
                else {
                    setAutoCrawlData(res)
                    setShowPopup(true);
                }
            }
            setLoader(false)
        }
        catch {
            setLoader(false)
        }
    }
    const closePopup = () => {
        setShowPopup(false)
    }
    const dwldTSGrid = async () => {
        try {
            setCsvLoader(true)
            const resp = await TSCsvDownload(statusData)
            if (resp === "downloaded") {
                SuccessMessage("Downloaded successfully !!")
            }
            setCsvLoader(false)
        }
        catch {
            setCsvLoader(false)
        }
    }
    const changeDownload = async (prop) => {
        const res = await downloadXL(prop, statusData)
    }
    const getDataBasedOnFreq = async (e, prop) => {
        if (prop !== undefined) {
            setFrequency(prop.key)
        }
        else { setFrequency('') }
    }
    const getDataBasedOnVMS = async (e, prop) => {
        if (prop !== undefined) {
            setVms(prop.key)
        }
        else { setVms('') }
    }
    const vmsOptions = ['Agile', 'Fieldglass', 'Beeline', 'Prowand', 'Green Resources', 'IQN', 'Econometrix',
        'Leoforce', 'Simplify', 'Vndly', 'Workforce Logiq'];
    return (
        <>
            <Layout style={{ backgroundColor: "white", height: "100vh", display: "flex", overflow: "hidden" }} >
                <SideNavBar />
                <Layout style={{ backgroundColor: "white", overflow: "hidden" }}>
                    <Header className="preview-header-class"><Navbar /></Header>
                    <Content style={{ overflow: 'auto', height: "100%" }}>
                        <div className="timesheet-first-div">
                            <div className="name-autocrawl">
                                <div className="timesheet-title">Timesheet Team</div>
                                <div className="notifictaion">
                                    <Button type="submit" className="autocrawl-button" onClick={openPopup}
                                        loading={loader}>Auto Crawl</Button>
                                    {showErrorMsg ? <div className="status-para">! Autocrawl is processing</div> : null}
                                </div>
                            </div>
                            <div className="ts-dwld-class">
                                <div className="ts-drop">
                                    <Select
                                        onSelect={changeDownload}
                                        className="ts-drowpdowns"
                                        placeholder={<span className="placeholder-span" style={{ color: 'rgba(0, 39, 102, 1)' }}>Download as</span>}
                                        style={{ width: 210, marginLeft: 15 }}
                                        options={[{ value: 'one', label: 'Action Required - Missing/Rejected/Pending Timecards', },
                                        { value: 'two', label: 'Report - Missing/Rejected/Submitted Timecards - A Reqs', },
                                        { value: 'three', label: 'REPORT - Missing/Rejected Timecards - C Reqs', },
                                        { value: 'four', label: 'REPORT - ST/OT/DT Timecard Errors', },]}

                                    />
                                </div>
                                <div>
                                    <Button loading={csvLoader} type="submit" className="tsdwnld-button" onClick={dwldTSGrid}>Download .CSV
                                        <UploadOutlined style={{ transform: "rotate(180deg)", fontSize: 16 }} /></Button>
                                </div>
                            </div>
                            <Modal
                                open={showPopup}
                                className="modal"
                                footer={false}
                                width={400}
                                onOk={openPopup}
                                onCancel={closePopup}

                            >
                                <div style={{ minHeight: 605 }}>
                                    <AutoCrawlSection statusdata={statusData}
                                        sendtoParent={setStatusData} autocrawl={autocrawlData} frequency={frequency}
                                        vms={vms} />
                                </div>
                            </Modal>
                        </div>
                        <div className="timesheet-second-div">
                            <label className="label-timesheet">VMS Client</label>
                            <Select className="ts-drowpdowns"
                                placeholder={<span className="placeholder-span" style={{ color: 'rgba(0, 39, 102, 1)' }}>Select VMS</span>}
                                style={{ width: 170, marginLeft: 15 }} size="medium" allowClear
                                onChange={(e, item) => getDataBasedOnVMS(e, item)}
                            >
                                {vmsOptions ? vmsOptions.map((item) => {
                                    return (<Select.Option key={item}>{item}</Select.Option>)
                                }) : null}
                            </Select>
                            <label className="label-timesheet">Payroll Type</label>
                            <Select className="ts-drowpdowns"
                                placeholder={<span className="placeholder-span" style={{ color: 'rgba(0, 39, 102, 1)' }}>Select Payroll Type</span>}
                                style={{ width: 170, marginLeft: 15 }}  allowClear
                                onChange={(e, key) => getDataBasedOnFreq(e, key)}
                            >
                                <Select.Option key={'Weekly'}>Weekly</Select.Option>
                                <Select.Option key={'Bi-Weekly'}>Bi-Weekly</Select.Option>
                            </Select>
                        </div>
                        <TimeSheetGrid statusdata={statusData} sendtoParent={setStatusData} vms={vms}
                            tableLoader={tableLoader} setTableLoader={setTableLoader} frequency={frequency} />
                    </Content>
                </Layout>
            </Layout>
        </>
    )
}
export default TimesheetTeam;